import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { AnnualTradingReportFilter } from "../types";

export const getAnnualDateReport = (
  user: User,
  filter: AnnualTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getannualtradingreport",
    params: {
      userid: user.userId,
      option: "D",
      year: filter.year,
    },
  });
};

export default getAnnualDateReport;
